import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface AppState {
    environment: string|null;
    project_key: string|null;
    project_name: string|null;
    page_title: string|null;
    force_fullscreen: boolean;
    is_invited:boolean | null;
}


export interface UpdateProjectState {
  project_key: string|null;
  project_name: string|null;
}
export interface UpdateProjectEnvironment {
  environment: string|null;
  project_key: string|null;
  project_name: string|null;
  is_invited: boolean|null;
}

const initialState: AppState = {
  environment: null,
  project_key: null,
  project_name: null,
  page_title: "Dashboard",
  force_fullscreen: false,
  is_invited:false
};

export interface UpdatePageState {
  page_title: string | null;
  force_fullscreen: boolean;
}


export const appstateSlice = createSlice({
  name: 'appstate',
  initialState: initialState,
  reducers: {
      updateProject: (state, action: PayloadAction<UpdateProjectState>) => {
        state.project_key = action.payload.project_key;
        state.project_name = action.payload.project_name;
      },
      updateEnvironment: (state, action: PayloadAction<string | null>) => {
        state.environment = action.payload;
      },
      updatePageState: (state, action: PayloadAction<UpdatePageState>) => {
        state.page_title = action.payload.page_title;
        state.force_fullscreen = action.payload.force_fullscreen;
      },
      updateAppState: (state, action: PayloadAction<UpdateProjectEnvironment>) => {
        state.environment = action.payload.environment;
        state.project_key = action.payload.project_key;
        state.project_name = action.payload.project_name;
        state.is_invited = action.payload.is_invited;
      },
      updateForceFullscreen: (state, action: PayloadAction<boolean>) => {
        state.force_fullscreen = action.payload;
      },
  },
})

export const { updateProject, updateEnvironment, updateAppState, updatePageState } = appstateSlice.actions;

// Export the reducer as default
export default appstateSlice.reducer;